'use client';

import { faMessageQuestion } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { IconButtonLink } from '@/components/ui/icon-button/icon-button.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

const MESSAGE_QUESTION_OPTICAL_CENTERING = 'translate-y-px';

export function NeedHelpButton() {
  return (
    <IconButtonLink
      prefetch={false}
      href="/preciso-de-ajuda/"
      icon={faMessageQuestion}
      iconClassName={MESSAGE_QUESTION_OPTICAL_CENTERING}
      label="Preciso de ajuda"
      data-testid={DataTestIdEnum.HEADER_NEED_HELP_BUTTON}
      data-analytics-event={AnalyticsEnum.CLICK_HEADER_NEED_HELP_BUTTON}
    />
  );
}
